// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from 'vue-cookies'
import Resource from 'vue-resource'
import 'lib-flexible/flexible'
import Mint from 'mint-ui';
import "mint-ui/lib/style.css"
import "./style/base.css"
import 'amfe-flexible/index.js'
import "amfe-flexible";
import common_js from './common/common.js';
import VueClipboard from 'vue-clipboard2' //复制插件
import {Dialog} from 'vant';
import {Uploader} from 'vant';
import {Toast} from 'vant';

Vue.use(Toast);
Vue.use(Uploader);
// 全局注册
Vue.use(Dialog);
Vue.use(VueCookies)
Vue.use(Resource)
Vue.use(Mint);
Vue.use(VueClipboard)

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


Vue.config.productionTip = false

const dre_code = common_js.getUrlCode().dre_code // 截取 dre_code
if (dre_code) {
    localStorage.setItem('dre_code', dre_code);
}
console.log('dre_code:', dre_code)

router.beforeEach((to, from, next) => {

    window.document.title = to.meta.title
    if (!window.initUrl) {
        window.initUrl = location.href
        // window.initUrl = location.href.split('#')[0]
    }
    next()
    // if(to.name == 'order'){
    //   next()
    // }else{
    //   next({name:'order'})
    // }
})
router.onError((error) => {

    // 这里的正则表达式可以根据实际情况下js命名来进行修改,“ (\d)+ ”只匹配数字

    const pattern = /Loading chunk (\d)+ failed/g;

    const isChunkLoadFailed = error.message.match(pattern);

    const targetPath = router.history.pending.fullPath;

    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }

});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js